var map = {
	"./alert.svg": 803,
	"./biohazard.svg": 5723,
	"./exclamation.svg": 5234,
	"./info.svg": 3103,
	"./ok.svg": 7213,
	"./radiation.svg": 3160,
	"./stop.svg": 3647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6300;